import { render, staticRenderFns } from "./BalanceNotification.vue?vue&type=template&id=049bfbee&scoped=true&"
import script from "./BalanceNotification.vue?vue&type=script&lang=js&"
export * from "./BalanceNotification.vue?vue&type=script&lang=js&"
import style0 from "./BalanceNotification.vue?vue&type=style&index=0&id=049bfbee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049bfbee",
  null
  
)

export default component.exports